function clearLocalStorage() {
    localStorage.removeItem("freeLesson");
    localStorage.removeItem("freeLessonStatus");
}

function currentDate() {
    const currentDate = new Date();
    const dateString = currentDate.toISOString();
    localStorage.setItem("currentDate", dateString);
}

function diffDate() {
    const storedDate = localStorage.getItem("currentDate");

    if (storedDate) {
        const storedDateObj = new Date(storedDate);
        const newCurrentDate = new Date();

        if (newCurrentDate.toDateString() !== storedDateObj.toDateString()) {
            clearLocalStorage();
            currentDate();
        } else {
            currentDate();
        }
    } else {
        clearLocalStorage();
        currentDate();
    }
}

diffDate();
